import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "post" };
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { updateBasicInfo } from "@/api/basic";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FooterEdit',
    emits: ["saved"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const dialogVisible = ref(false);
        const title = ref("修改底部信息");
        const form = reactive({
            businessPhone: "",
            servicePhone: "",
            address: "",
        });
        const show = (data) => {
            form.businessPhone = data?.businessPhone || "";
            form.servicePhone = data?.servicePhone || "";
            form.address = data?.address || "";
            dialogVisible.value = true;
        };
        const handleConfirm = async () => {
            try {
                const res = await updateBasicInfo({
                    id: 1,
                    businessPhone: form.businessPhone,
                    servicePhone: form.servicePhone,
                    address: form.address,
                });
                ElMessage.success("保存成功");
                dialogVisible.value = false;
                emit("saved", res.data);
            }
            catch {
                ElMessage.error("保存失败");
            }
        };
        __expose({ show });
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_form = _resolveComponent("el-form");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_el_dialog, {
                    modelValue: dialogVisible.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((dialogVisible).value = $event)),
                    title: title.value,
                    "close-on-click-modal": false,
                    "append-to-body": "",
                    center: "",
                    style: { "width": "25%" }
                }, {
                    footer: _withCtx(() => [
                        _createVNode(_component_el_button, {
                            onClick: _cache[3] || (_cache[3] = ($event) => (dialogVisible.value = false))
                        }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                    _createTextVNode("取消", -1)
                                ]))]),
                            _: 1
                        }),
                        _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: handleConfirm
                        }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                    _createTextVNode("确认", -1)
                                ]))]),
                            _: 1
                        })
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_component_el_form, {
                            model: form,
                            ref: "formRef",
                            "label-width": "auto",
                            size: "default"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "商务合作：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.businessPhone,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.businessPhone) = $event)),
                                            placeholder: "请填写商务合作电话"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "客服热线：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.servicePhone,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.servicePhone) = $event)),
                                            placeholder: "请填写客服热线"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "地址：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.address,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.address) = $event)),
                                            placeholder: "请填写地址"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["model"])
                    ]),
                    _: 1
                }, 8, ["modelValue", "title"])
            ]));
        };
    }
});
